/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
import React from 'react';
import Head from 'next/head';
import Article from '../../Components/Article';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import Accordion from '../../Components/AccordionLight';
import NavBarVertical from '../../Components/NavBarVertical';
import NavBarMobile from '../../Components/NavBarMobile';

class Profile03 extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">EDvice</title>
          <meta key="og:title" property="og:title" content="EDvice" />
          <meta key="description" name="description" content="EDvice" />
          <meta key="og:description" property="og:description" content="EDvice" />
        </Head>
        <Navbar>Navbar</Navbar>
        <div className="feature-exams">
          <DigitalDisplay
            color="red"
            image={require('./linguaskill_desktop.png')}
            column="col-xs-5"
          >
            <Article>
              <header className="exams__header" id="exams">
                <h2>
                  <strong>Information about the Linguaskill test</strong>
                </h2>
              </header>
            </Article>
          </DigitalDisplay>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <NavBarMobile />
              <NavBarVertical />
            </div>
            <div className="col-sm-8 col-xs-12 col-md-8 col-lg-8">
              <div className="content-inner">
                <div className="profile-format-content">
                  <img alt="Research" src={require('./science01.jpg')} />
                  <div>
                    <h1>Martin Robinson</h1>
                    <p>Assistant Director, Assessment</p>
                  </div>
                </div>
                <p>
                  Martin Robinson joined Cambridge Assessment in 2002 and is responsible for the
                  development and production of its automated, adaptive assessments, including
                  Linguaskill and BULATS. In addition, Martin manages the Cambridge English
                  Benchmarking service and through his work in these areas he has led national
                  projects for ministries of education in countries including Malaysia, Chile and
                  Malta, as well as managing language test production for the European Commission’s
                  European Survey on Language Competences. Before joining Cambridge English he
                  gained extensive experience in English language teaching and school management in
                  Spain and Japan. He holds an MA in Applied Linguistics, specialising in language
                  assessment, from the University of Reading.
                </p>
                <div className="profile__section">
                  <Accordion>
                    <div label="Describe your role and involvement in Linguaskill.">
                      <h3>Describe your role and involvement in Linguaskill.</h3>
                      <p>
                        As product owner, I’m responsible for taking customer requirements and
                        developing an end-to-end solution that satisfies those needs. This includes
                        developing the tests, the delivery platform, the automated marking
                        capability, right through to delivering the results to the customer.
                      </p>
                    </div>
                    <div label="What were the needs you were looking to solve with Linguaskill?">
                      <h3>What were the needs you were looking to solve with Linguaskill?</h3>
                      <p>
                        Our customers would like assessment that is under their control, is totally
                        on demand and can be taken 24/7/365, and where results are delivered almost
                        instantly.
                      </p>
                    </div>
                    <div label="What makes Linguaskill different from other tests?">
                      <h3>What makes Linguaskill different from other tests?</h3>
                      <p>
                        The adaptive element is very different from traditional testing. Some
                        organisations provide adaptive testing but the Cambridge English technology
                        is more advanced.
                      </p>
                      <p>
                        We not only provide one test that covers all levels but the algorithm also
                        ensures coverage of the entire test construct. This means we are testing all
                        the different sub- skills that we need to test, and that different
                        candidates and even the same candidate taking the test more than once
                        receive different tests. We also automark extended writing, such as 200-word
                        pieces, and provide results in terms of the Common European Framework of
                        Reference for Languages (CEFR).
                      </p>
                    </div>
                    <div label="Now that Linguaskill is in the market, what are you most satisfied with in terms of the product and market adoption?">
                      <h3>
                        Now that Linguaskill is in the market, what are you most satisfied with in
                        terms of the product and market adoption?
                      </h3>
                      <p>
                        The fact that our customers can buy tests and arrange all their own test
                        sessions, and access reports through one platform. In traditional testing
                        this all takes many months and huge numbers of people across the world. So,
                        when customers say that they can do all this themselves and it’s all really
                        easy, that’s great feedback. We’ve also had lots of comments from students
                        telling us that this is the future of testing. They want to know why all
                        their tests aren’t like this! That’s fantastic to hear.
                      </p>
                    </div>
                    <div label="How do you see Linguaskill developing over the next 2–3 years?">
                      <h3>How do you see Linguaskill developing over the next 2–3 years?</h3>
                      <p>
                        We’ll automate even more so that it’s even easier and quicker for customers,
                        and we’ll provide them with more choice. We’ll also be delivering more
                        feedback to learners and teachers that will help them learn English better.
                      </p>
                    </div>
                    <div label="How do you see computer-based testing changing in the future, particularly with the use of AI?">
                      <h3>
                        How do you see computer-based testing changing in the future, particularly
                        with the use of AI?
                      </h3>
                      <p>
                        This is going to be very exciting. We’re going to be doing research into
                        AI-based dialogue systems so that in a few years we might be able to start
                        having learners converse with a computer rather than just answer questions.
                        This is very early days in the concept, and will require a lot of research,
                        but AI does make it potentially possible.
                      </p>
                    </div>
                    <div label="Are there other key trends that you see impacting language learning and testing over the next five years?">
                      <h3>
                        Are there other key trends that you see impacting language learning and
                        testing over the next five years?
                      </h3>
                      <p>
                        Yes. People often talk about ‘localising’ testing, meaning that tests are
                        specially created for a particular country or other group. This is a good
                        first step, but I think we can look to go beyond that. I see personalised
                        learning and testing as the future, so every individual, whether they’re in
                        a classroom or at home, receives a test or a piece of learning that is
                        especially created solely for them as part of a personalised learning path
                        that takes them to where they need to get to. This is all possible with
                        adaptive technologies, machine learning and data (lots and lots of data!).
                      </p>
                    </div>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </React.Fragment>
    );
  }
}
export default Profile03;
